<template>
  <footer class="hidden-print">
    <div class="container flush-outside">
      <div class="row">
        <div class="col-xs-12">
          <h5><strong>{{ $t('questions') }}</strong></h5>
          <p>
              {{ $t('contact_us') }}<br>
              {{ $t('opening_hours') }}<br>
              {{ $t('tel') }} <a href="tel:+4922194714567">+49 221 94714-567</a><br>
              {{ $t('email') }} <a href="mailto:service@gs1-germany.de?subject=Verified%20by%20GS1">service@gs1-germany.de</a>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 footer-links">
          <hr>
          <a href="https://www.gs1-germany.de/" target="_blank" rel="noopener">{{ $t('links.gs1_germany') }}</a>
          <span class="link-pipe">|</span>
          <a href="https://www.gs1-germany.de/newsletter/" target="_blank" rel="noopener">{{ $t('links.newsletter') }}</a>
          <span class="link-pipe">|</span>
          <a href="https://www.gs1-germany.de/impressum/" target="_blank" rel="noopener">{{ $t('links.imprint') }}</a>
          <span class="link-pipe">|</span>
          <a href="https://www.gs1-germany.de/datenschutz/" target="_blank" rel="noopener">{{ $t('links.privacy') }}</a>
          <span class="link-pipe">|</span>
          <router-link :to="{ name: 'TermsOfUse' }">{{ $t('links.terms_of_use') }}</router-link>
          <span class="link-pipe">|</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  i18n: {
    messages: {
      de: {
        questions: 'Sie haben Fragen?',
        contact_us: 'Kontaktieren Sie uns:',
        opening_hours: 'Mo. bis Fr., 9:00 – 17:00 Uhr',
        tel: 'Tel:',
        email: 'E-Mail:',
        links: {
          gs1_germany: 'GS1 Germany',
          newsletter: 'Newsletter',
          imprint: 'Impressum',
          privacy: 'Datenschutz',
          terms_of_use: 'AGB'
        }
      },
      en: {
        questions: 'Do you have questions?',
        contact_us: 'Contact us:',
        opening_hours: 'Mon–Fri from 9:00–17:00 o’clock',
        tel: 'Tel:',
        email: 'Email:',
        links: {
          gs1_germany: 'GS1 Germany',
          newsletter: 'Newsletter',
          imprint: 'Imprint',
          privacy: 'Privacy Policy',
          terms_of_use: 'Terms of Use'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue